<template>
  <div>
    <div class="container-alb filter-mobile">
      <table
        cellpadding="10"
        cellspacing="0"
        width="95%"
        class="hover-table"
        align="center"
      >
        <tr>
          <td>
            {{ $t("finance.taxNumberLabel") }}
            <form
              @submit.prevent="
                {
                return false;
              }
                "
            >
              <input
                type="text"
                class="formedituser"
                v-model="filters.taxNumber"
                v-on:keyup.enter="searchMandates()"
              />
            </form>
          </td>
          <td>
            {{ $t("finance.mandateNameLabel") }}
            <form
              @submit.prevent="
                {
                return false;
              }
                "
            >
              <input
                type="text"
                class="formedituser"
                v-model="filters.name"
                v-on:keyup.enter="searchMandates()"
              />
            </form>
          </td>
                    <td>
            {{ $t("finance.mandateStatusLabel") }}
              <form
              @submit.prevent="
                {
                return false;
              }
                "
            >
              <select class="filtrare" v-model="filters.status">
                <option v-for="(entry, index) in statuses" :key="index" :value="entry"
                  :selected="entry  === filters.status">
                  {{ $t('finance.mandateStatus_' + entry) }}
                </option>
              </select>
            </form>
          </td>
        </tr>
        <tr>
          <td>
            <a
                  class="notification-action custom-notification-action"
                  @click="searchMandates()"
                  >{{ $t("searchButtonLabel") }}</a
                >
          </td>
        </tr>
      </table>
    </div>

    <!-- card transaction -->
    <div class="container-alb">
            <MandatesTable
        :mandates="this.mandatesList"
      />
      <!-- <tr v-if="this.companyOrders === null">
          <td colspan="6">
            <div class="loading">
              <img src="@/assets/images/loading.gif" />
            </div>
          </td>
        </tr> -->
      <br />


      <div
        class="error-wrapper border-box"
        v-if="this.mandatesList && this.mandatesList.length === 0"
      >
        <p>{{ $t("finance.noMandateLabel") }}</p>
      </div>

      <div class="pagination-wrapper border-box">
        <b-pagination
          v-model="currentPage"
          :total-rows="this.mandatesCount"
          :per-page="perPage"
          size="sm"
        ></b-pagination>
      </div>
    </div>
    <div id="modal_popup_info" class="modal-popup">
      <div class="modal-popup-content">
        <a
          @click="showModalPopup('modal_popup_info', false)"
          class="close-button"
        >
          <img src="@/assets/images/close-button.svg" />
        </a>
        <div v-if="this.error">
          <p v-html="$t('errorActionBeneficiary_' + this.error.code)"></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import httpServiceFinance from "@/http/http-finance.js";
  import { BPagination } from "bootstrap-vue";
  import Cookies from "js-cookie";
  import MandatesTable from "./MandatesTable.vue";

  export default {
    props: {
      msg: String,
    },
    components: {
      "b-pagination": BPagination,
      MandatesTable
      // Multiselect
    },
    data() {
      return {
        transactionError: null,
        mandatesList: [],
        tempInvoices: null,
        statuses: ["", "A", "E"],
        filters: {
          taxNumber: "",
          name: "",
          status: "",
        },
        mandatesCount: 10,
        perPage: 10,
        currentPage: 1,
        sortField: "created",
        sortDirection: "asc",
        selectedProduct: null,
        error: null,
      };
    },
    methods: {
      productSelected(event) {
        this.filters.product = event.target.value;
        this.searchMandates();
      },
      isSelectedProduct(product) {
        return product === this.filters.product;
      },
      sortBy(sortField, sortDirection, status) {
        this.sortField = sortField;
        this.sortDirection = sortDirection;
        this.searchMandates(status);
      },
      searchMandates() {
        this.error = null;
        this.mandatesList = null;

        var mandatesData = "?"
        mandatesData +=
          "&per_page=" +
          this.perPage +
          "&page=" +
          this.currentPage +
          "&sort=" +
          this.sortDirection;
        if (this.sortDirection === "desc") {
          mandatesData += "&desc=" + this.sortField;
        } else {
          mandatesData += "&asc=" + this.sortField;
        }

        if (this.filters.taxNumber.trim().length > 0) {
          mandatesData += "&tax_number=" + this.filters.taxNumber;
        }
        if (this.filters.name.trim().length > 0) {
          mandatesData += "&name=" + this.filters.name;
        }
        if (this.filters.status.trim().length > 0) {
          mandatesData += "&status=" + this.filters.status;
        }

        httpServiceFinance.financeService
          .searchClientMandates(mandatesData, Cookies.get("token"))
          .then(function (response) {
            return response;
          })
          .catch((error) => {
            return error.response;
          })
          .then((response) => {

            if (response.status == 200) {
              this.mandatesList = response.data;
              // this.mandatesList = [{
              //   id: 100,
              //   taxNumber: "RO12345678",
              //   name: "UP ROMANIA SRL",
              //   status: "A",
              //   created: 1780775433166
              // }]
              this.mandatesCount = response.headers["x-up-count"];
            } else if (response.status == 400) {
              this.error = { code: response.data.error_code };
            } else {
              this.error = { code: response.error_code };
            }
            if (this.error) {

              this.showModalPopup("modal_popup_info", true);
            }
            this.showModalPopup("modal_popup_loading", false);
          })

      },
      selectProduct(index) {
        this.selectedProduct = this.cardProducts[index];
      },
    },
    mounted() {
      this.searchMandates();
    },
    watch: {
      currentPage: function () {
        this.searchMandates();
      },
    },
  };
</script>

<style scoped src="@/assets/styles/beneficiary.css"></style>
<style>
  .page-link {
    color: #4a4a4a;
  }

  .page-link:hover {
    color: #4e5b59;
  }

  .page-item.active .page-link {
    background-color: #4e5b59 !important;
    border-color: #4e5b59 !important;
  }

  .invoices-filter .reportrange-text {
    height: 27px;
    font-size: 13px;
    padding: 3px 10px;
    border: none !important;
    color: #585858;
    background: #f1f1f1;
  }
</style>
